import styled from 'styled-components';
import { Title } from 'components/Toolkit/InfoTitle/Title/Title';

const Header = styled(Title)`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

const Body = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export { Header, Body };
